import React from 'react';
import { Input, Label } from 'reactstrap';
import propTypes from 'prop-types';
import classnames from 'classnames';

import { makeId } from 'utils/selectors';

import styles from './ContentContext.css';
import * as constants from '../const';

const CheckboxList = ({
  customScroll,
  name,
  listElements,
  selectedCheckboxes,
  indent,
  isReadonly,
  handleChange,
  handleChangeType,
  indeterminate
}) => {
  const indeterminateCountries = Object.keys(indeterminate).filter(
    country => indeterminate[country]
  );

  /* handles labels that have values that display differently in the Canvas UI
  than how the value is saved in the database/cache */
  const renderLabel = (value, name) => {
    let label = value;
    if (name === constants.US_LOCAL_MARKET) {
      switch (value) {
        case 'LA':
          label = 'Los Angeles';
          break;
        case 'NY':
          label = 'New York City';
          break;
        case 'SF':
          label = 'San Francisco';
          break;
        default:
          break;
      }
    }
    return label;
  };

  return (
    <div className={classnames([customScroll && styles.customScroll, 'pb-3'])}>
      <div className="pb-2">{name === constants.US_LOCAL_MARKET ? '' : name}</div>
      {listElements.map(value => (
        <div
          key={value}
          className={classnames([
            (customScroll && styles.inputIndent) || (indent && styles.inputIndent),
            'd-flex'
          ])}
        >
          {indeterminateCountries.includes(value) ? (
            <Input
              disabled={isReadonly}
              type="checkbox"
              id={value}
              data-test-id={`cc-checkbox-indeterminate-${makeId({ value })}`}
              className={styles.indeterminate}
              onChange={() => {
                return handleChange(constants.SELECT_ALL, constants[`${value}_COUNTRY_CODE`]);
              }}
            />
          ) : (
            <Input
              disabled={isReadonly}
              type="checkbox"
              id={value}
              data-test-id={`cc-checkbox-${makeId({ value })}`}
              checked={selectedCheckboxes.includes(value)}
              className={styles.checkboxMargin}
              onChange={() => handleChange(value, handleChangeType)}
            />
          )}
          <Label htmlFor={value} className={styles.labelCheckBox}>
            {renderLabel(value, name)}
          </Label>
        </div>
      ))}
    </div>
  );
};

CheckboxList.propTypes = {
  customScroll: propTypes.bool,
  name: propTypes.node,
  listElements: propTypes.array.isRequired,
  selectedCheckboxes: propTypes.array.isRequired,
  indent: propTypes.bool,
  isReadonly: propTypes.bool.isRequired,
  handleChange: propTypes.func.isRequired,
  handleChangeType: propTypes.string.isRequired,
  indeterminate: propTypes.object
};

CheckboxList.defaultProps = {
  customScroll: false,
  name: '',
  indeterminate: {
    US: false
  },
  indent: false
};

export default CheckboxList;
